import { useCallback } from "react";
import { useUpdateUploadMutation } from "../../eventCreationWorkflowV2/slices/uploadApi";
import { useLazyGetSingleAssetFromStrapiQuery } from "../../eventCreationWorkflowV2/slices/uploadGetApi";

type UploadResult = {
  assetId: string;
  url: string;
};

export function useStrapiImageUpload() {
  const [uploadStrapiFile] = useUpdateUploadMutation();
  const [getImageFromStrapi] = useLazyGetSingleAssetFromStrapiQuery();

  const fetchImageUrlByAssetId = useCallback(
    async (assetId: string): Promise<string> => {
      if (!assetId) return "";

      const res = await getImageFromStrapi(assetId).unwrap();
      if (res && res.data && res.data.length > 0) {
        return res.data[0].url || "";
      }

      return "";
    },
    [getImageFromStrapi]
  );

  const uploadImageToStrapi = useCallback(
    async (file: File): Promise<UploadResult> => {
      const fd = new FormData();
      fd.append("files", file);
      fd.append("fileInfo", "{}");

      try {
        const res = await uploadStrapiFile(fd).unwrap();
        const assetId = res?.[0]?.id ?? "";
        const url = await fetchImageUrlByAssetId(assetId);

        return { assetId, url };
      } catch (err) {
        console.error("Error uploading file to Strapi:", err);
        return { assetId: "", url: "" };
      }
    },
    [fetchImageUrlByAssetId, uploadStrapiFile]
  );

  return {
    uploadImageToStrapi,
    fetchImageUrlByAssetId
  };
}
